/**
 * @file auth.js
 * @description Interceptor de autenticação para CRA
 */

/**
 * Obtém token de autenticação do localStorage
 * @returns {Promise<string|null>} Token de autenticação ou null
 */
export async function getAuthToken() {
  if (typeof window === "undefined" || typeof localStorage === "undefined") {
    return null
  }

  try {
    const user = localStorage.getItem("user_token")

    if (user) {
      const parsed = JSON.parse(user)
      return parsed.token
    }
  } catch (error) {
    console.error("Error reading auth token from localStorage:", error)
  }

  return null
}

/**
 * Obtém headers de autenticação
 * @returns {Promise<HeadersInit>} Headers com token de autenticação
 */
export async function getAuthHeaders() {
  const token = await getAuthToken()

  if (!token) {
    return {}
  }

  return {
    Authorization: `Bearer ${token}`,
  }
}

/**
 * Limpa dados de autenticação do localStorage
 */
export function clearAuthData() {
  if (typeof window !== "undefined" && typeof localStorage !== "undefined") {
    localStorage.removeItem("user_token")
  }
}

/**
 * Limpa cookie de autenticação (não usado em CRA, mas mantido para compatibilidade)
 */
export function clearAuthCookie() {
  // Em CRA, não usamos cookies, apenas localStorage
  clearAuthData()
}

/**
 * Define cookie de autenticação (não usado em CRA, mas mantido para compatibilidade)
 */
export function setAuthCookie(token) {
  // Em CRA, não usamos cookies, apenas localStorage
  if (typeof window !== "undefined" && typeof localStorage !== "undefined") {
    localStorage.setItem("user_token", JSON.stringify({ token }))
  }
}
